import styled from 'styled-components';
import { BodyRegularS, CaptionRegularL, HeadingExtraBoldM } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ISurveyAccordionStyles {
  theme: ITheme;
  active?: boolean;
}

export const AccordionCont = styled.div<ISurveyAccordionStyles>`
  width: 100%;
  position: relative;
  border-radius: 0 8px 8px 0;

  ${({ theme, active }: ISurveyAccordionStyles) => `
    margin: 0 0 ${theme.layout.spacing.centy} 0;
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: 0 1px 1px ${theme.colors.neutral.primary[30]};
    
    &::after {
      content: '';
      width: 4px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: ${active ? theme.colors.secondary[100] : 'transparent'};
    }
  `}
`;

export const SurveyInfoCont = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 168px 32px 32px;
`;

export const RemoveIcon = styled.div`
  display: flex;
  padding-left: 10px;

  svg {
    width: 18px;
    height: 18px;
    cursor: pointer;

    path {
      fill: rgb(237, 52, 44);
    }
  }
`;

export const SurveyInfoTitle = styled(HeadingExtraBoldM)`
  display: flex;

  ${({ theme }: IThemeProvider) => `
        margin: 0 0 ${theme.layout.spacing.decy} 0;
  `}
`;

export const SurveysInfoStats = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
         margin: 0 0 ${theme.layout.spacing.centy} 0;
         color:  ${theme.colors.neutral.primary[80]};
  `}
`;

export const SurveysInfoDesc = styled(CaptionRegularL)`
  ${({ theme }: IThemeProvider) => `
        margin: 0 0 ${theme.layout.spacing.deka} 0;
  `}
`;

export const CloseOpenIconCont = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 25px;
  right: 24px;
`;
